module.exports = __webpack_public_path__ + "img/ico_download.576fac10.svg";